import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import BenefitsSection from '@/pages/home/components/BenefitsSection';
import GallerySection from '@/pages/home/components/GallerySection';
import EmotionalSection from '@/pages/home/components/EmotionalSection';
import ContactSection from '@/pages/home/components/ContactSection';
import Footer from '@/pages/home/components/Footer';
import WhatsAppButton from '@/pages/home/components/WhatsAppButton';

export default function Home() {
  return (
    <div className="font-body bg-brand-white">
      <Navbar />
      <HeroSection />
      <GallerySection />
      <BenefitsSection />
      <EmotionalSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
